module.exports = __webpack_public_path__ + "media/images/bitcoin-c9f33461d5d0cb6b0debc19423e47af1.svg";